import * as Yup from 'yup';
import { stringRequired } from '.';

export const smsMessageComposeSchema = Yup.object({
    to: stringRequired,
    message: stringRequired
});